// @flow
import {action} from 'mobx';
import FormSetUnpublishedToolbarAction from 'sulu-admin-bundle/views/Form/toolbarActions/SetUnpublishedToolbarAction';
import ResourceRequester from 'sulu-admin-bundle/services/ResourceRequester';
import {translate} from 'sulu-admin-bundle/utils/Translator';

/**
 * Overrides the default SetUnpublishedToolbarAction from sulu-admin-bundle to add proper error handling.
 *
 * The original implementation has no .catch() handler on the unpublish request, which causes the
 * confirmation dialog to remain stuck in loading state when the server returns an error (e.g. 422).
 */
export default class SetUnpublishedToolbarAction extends FormSetUnpublishedToolbarAction {
    @action handleUnpublishDialogConfirm = () => {
        const {
            id,
            locale,
            options: {
                webspace,
            },
            resourceKey,
        } = this.resourceFormStore;

        if (!id) {
            throw new Error(
                'The page can only be unpublished if an ID is given! This should not happen and is likely a bug.'
            );
        }

        this.unpublishing = true;

        ResourceRequester.post(
            resourceKey,
            undefined,
            {
                action: 'unpublish',
                locale,
                id,
                webspace,
            }
        ).then(action((response) => {
            this.unpublishing = false;
            this.showUnpublishDialog = false;
            this.form.showSuccessSnackbar();
            this.resourceFormStore.changeMultiple(response, {isServerValue: true});
            this.resourceFormStore.dirty = false;
        })).catch(action((errorResponse) => {
            this.unpublishing = false;
            this.showUnpublishDialog = false;

            errorResponse.json().then(action((data) => {
                this.form.errors.push(
                    data.detail || data.title || translate('sulu_admin.form_save_server_error')
                );
            })).catch(action(() => {
                this.form.errors.push(translate('sulu_admin.form_save_server_error'));
            }));
        }));
    };
}
